import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import ArmedIntroductionStore from './store';
import cx from 'classnames';
import Link from '@src/components/link';
import BaseSwiper from '@src/components/swiper/base-swiper';
import toWebpImage from '@src/utils/to-webp-image';

const styles = require('./index.less');

//
const ArmedIntroduction = ({ store }) => {
  store.use();

  //console.log(store.mechaStore?.pageData?.en_name_image, '??????');

  /**
   * 渲染武器按钮
   * @param item
   * @param index
   * @returns {JSX.Element}
   */
  const renderTabBtn = (item, index) => {
    const isActive = store.currentIndex === index;
    return (
      <div
        key={index}
        className={styles.tabItem}
        onClick={() => {
          store.clickTab(index);
        }}
      >
        <img className={styles.tabItem_img} src={isActive ? item.armed_icon_active : item.armed_icon} alt="" />
      </div>
    );
  };
  return (
    <div className={cx(styles.ArmedIntroductionBox)}>
      <div className={styles.videoBox}>
        <div className={styles.video_cover} style={{ backgroundImage: `url(${store.videoCover})` }} />
        {/* <Video /> */}
        <Link
          className={styles.videobtn}
          onClick={() => {
            store.videoOpen();
          }}
        />
        <div className={styles.videoFrame} />
        <div className={styles.videoName}>
          <div className={styles.videoNameText}>{store.weaponType}</div>
        </div>
      </div>
      <div className={cx(styles.tabList, store.weaponMsg?.length < 4 && styles.tabList2)}>
        {store.weaponMsg?.length > 0 &&
          store.weaponMsg?.map((item, index) => {
            return renderTabBtn(item, index);
          })}
      </div>
      <div className={styles.line} />
      <div className={styles.swiper_box}>
        {store.weaponMsg &&
          store.weaponMsg?.length > 0 && (
            <BaseSwiper store={store.weaponSwiper}>
              {store.weaponMsg.map((item, index) => {
                return (
                  <div key={index}>
                    <div className={styles.bipedstriker} style={{ backgroundImage: `url(${toWebpImage(require('./images/bipedstriker.png'))})` }}>
                      {item.weapon_name}
                    </div>
                    <div className={styles.short_desc}>{item.short_desc}</div>
                    <div className={styles.weaponIntroduction}>{item.desc}</div>
                  </div>
                );
              })}
            </BaseSwiper>
          )}
      </div>
    </div>
  );
};

export default wrapStore(ArmedIntroduction, ArmedIntroductionStore);
